import { Chip, Grid, TextField } from '@material-ui/core';
import React from 'react'
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { selectTaxiStations, selectTaxiCompany } from 'redux/actions/taxis/taxisActions';

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};


export const TaxiInputs = () => {
  const {companiesList} = useSelector(({companies}) => companies)
  const {companySelected, stations, stationsSelected} = useSelector(({taxis}) => taxis)

  const dispatch = useDispatch()

  const handleSelectCompany = (e, value) => {
    const newVal = value ? value : {}
    dispatch(selectTaxiCompany(newVal))
  }
  
  const handleSelectStations = (e, value) => {
    const newVal = value ? value : []
    dispatch(selectTaxiStations(newVal))
  }
  return (
    <form onSubmit>
      <Grid container spacing={1}>
      <Grid item xs={12} sm={3} style={style}>
          <Autocomplete
            id="combo-box-demo"
            options={companiesList}
            value={companySelected}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                name="stations"
                label="Empresa"
                variant="outlined"
              />
            )}
            fullWidth
            onChange={(e, v) => handleSelectCompany(e, v)}
            noOptionsText="No se encuentra la Empresa"
            closeIcon={
              <CloseIcon fontSize="small" />
            }
          />
        </Grid>
        <Grid item xs={12} sm={9} style={style}>
          <Autocomplete
          // disabled={!validateObject(companySelected)}
            id="combo-box-demo"
            options={stations}
            value={stationsSelected}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Plantas ${stations.length > 0 ? ' - Disponibles ' + stations.length  : ''}`}
                variant="outlined"
              />
            )}
            fullWidth
            onChange={(e, v) => handleSelectStations(e, v)}
            noOptionsText="No se encuentra la Plantas"
            limitTags={5}
            multiple
            closeIcon={
              <CloseIcon
                fontSize="small"
                style={{
                  borderRadius: '50%'
                }}
              />
            }
          />
        </Grid>
      </Grid>
    </form>
  )
}
